import colors from './foundation/color';
import components from './components';
import typography from './foundation/typography';
import space from './foundation/space';
import global from './foundation/global';
const ihTheme = {
    colors,
    components,
    ...typography,
    shadows: {
        s: '0px 4px 4px rgba(0, 0, 0, 0.08)',
        m: '0px 8px 8px rgba(0, 0, 0, 0.16)',
        l: '0px 16px 16px rgba(0, 0, 0, 0.16)'
    },
    sizes: {
        container: {
            sm: '640px',
            md: '768px',
            lg: '1024px',
            xl: '1280px',
            '2xl': '1440px'
        }
    },
    space,
    styles: {
        global
    }
};
export default ihTheme;

//# sourceMappingURL=index.js.map